(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-image-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedVideos = new WeakSet();

    function initializeSoundToggles(root) {
      root.querySelectorAll('[data-rennvox-image-text-video]').forEach((figure) => {
        const video = figure.querySelector('video');
        const button = figure.querySelector('.rennvox-image-text-sound-toggle');
        if (!video || !button || initializedVideos.has(video)) return;
        initializedVideos.add(video);

        function updateButton() {
          const soundOn = !video.muted && video.volume > 0;
          button.querySelector('span').textContent = soundOn ? '🔊' : '🔇';
          button.setAttribute('aria-pressed', String(soundOn));
          button.setAttribute('aria-label', soundOn ? button.dataset.soundOffLabel : button.dataset.soundOnLabel);
        }

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const soundOn = !video.muted && video.volume > 0;
          if (!soundOn && video.volume === 0) video.volume = 1;
          video.muted = soundOn;
          updateButton();
        });
        video.addEventListener('volumechange', updateButton);
        updateButton();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeSoundToggles(document), { once: true });
    } else {
      initializeSoundToggles(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeSoundToggles(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
